import React from 'react'

import { EMPTY_OBJECT } from '~/src/Lib/Utils'

export const DashboardContext = React.createContext(EMPTY_OBJECT)
export const ChartContext = React.createContext(EMPTY_OBJECT)
